import { Typography } from "@mui/material";
import { ReactElement } from "react";

import { DeleteManyState, TableControls } from "~frontend/components/Table";

import { CAMPAIGN_SORTS, CAMPAIGN_STATUSES } from "./constants";

export default function CampaignListControls({
  onAdvancedSearchClick,
  advancedSearchFiltersApplied,
  showAdvancedSearchButton,
  onClickNewCampaign,
  createCampaignLoading,
  statusFilter,
  setStatusFilter,
  search,
  setSearch,
  sort,
  setSort,
  noMessagingStrategies,
  deleteManyState,
  setDeleteManyState,
  onDeleteSelected,
}: {
  onClickNewCampaign: () => Promise<void>;
  onAdvancedSearchClick: () => void;
  advancedSearchFiltersApplied: number;
  showAdvancedSearchButton: boolean;
  createCampaignLoading: boolean;
  statusFilter: string[];
  setStatusFilter: (newStatusFilter: string[]) => void;
  search: string;
  setSearch: (newSearch: string) => void;
  sort: string;
  setSort: (newSort: string) => void;
  noMessagingStrategies: boolean;
  deleteManyState: DeleteManyState;
  setDeleteManyState: (newState: DeleteManyState) => void;
  onDeleteSelected: () => void;
}): ReactElement {
  const searchButtons = [];
  if (showAdvancedSearchButton) {
    searchButtons.push({
      label: (
        <>
          <Typography variant="body2">Advanced Search</Typography>
          {advancedSearchFiltersApplied > 0 && (
            <Typography variant="body2Bold">{`(${advancedSearchFiltersApplied})`}</Typography>
          )}
        </>
      ),
      onClick: onAdvancedSearchClick,
      id: "advanced-search",
    });
  }
  return (
    <TableControls
      addButtons={[
        {
          label: createCampaignLoading
            ? "Creating Campaign..."
            : "New Campaign",
          onClick: onClickNewCampaign,
          id: "new-campaign",
          disabled: noMessagingStrategies,
          tooltipTitle: noMessagingStrategies
            ? "No sending numbers available. You must set up a sending number before creating a campaign."
            : undefined,
        },
      ]}
      addSearchButtons={searchButtons}
      deleteMany={{
        deleteManyState,
        setDeleteManyState,
        onDeleteSelected,
        deleteMultipleButtonText: "Archive Multiple Campaigns",
        deleteSelectedButtonText: "Archive Selected Campaigns",
      }}
      filters={[
        {
          id: "status",
          label: "Campaign Status",
          value: statusFilter,
          onChange: setStatusFilter,
          options: CAMPAIGN_STATUSES.map(status => ({
            value: status.value,
            label: status.label,
          })),
          multi: true,
        },
      ]}
      sort={{
        value: sort,
        onChange: setSort,
        options: CAMPAIGN_SORTS.map(sort => ({
          value: sort.value,
          label: sort.label,
        })),
      }}
      search={{
        value: search,
        onChange: setSearch,
        placeholder: "Search for a campaign...",
      }}
    />
  );
}
